import {useLazyQuery, useMutation} from '@apollo/client';
import {activityMutations, activityQueries} from 'api/graphql-queries';
import {
    ActivitiesByObjectIdAndObjectTypePaginationResponse,
    ActivityModel,
    ActivityResponse,
    ActivityUpdateModelInput,
    ActivtyGetAllbyObjectIdRequest,
    CreateActivityRequest,
    ResponseViewModel,
} from 'models';

export const useGetActivitiesByObjectTypeAndObjectIdAPI = () => {
    const [refetch, {data, loading}] = useLazyQuery<
        ActivitiesByObjectIdAndObjectTypePaginationResponse,
        ActivtyGetAllbyObjectIdRequest
    >(activityQueries.ACTIVITIES_BY_OBJECT_ID_AND_OBJECT_TYPE, {
        fetchPolicy: 'no-cache',
    });

    return {
        acitivtyByObjectIdAndObjectTypeResponse: data?.activitiesByObjectIdAndObjectType,
        activityByObjectIdAndObjectTypeLoading: loading,
        activityByObjectIdAndObjectType: refetch,
    };
};

export const useCreateActivityAPI = () => {
    const [createActivity, {data, loading}] = useMutation<{createActivity: ActivityModel}, CreateActivityRequest>(
        activityMutations.CREATE_ACTIVITY,
    );

    return {
        createActivity,
        createActivityLoading: loading,
        createActivityResponse: data?.createActivity,
    };
};

export const useUpdateActivityApi = () => {
    const [updateActivity, {data, loading}] = useMutation<
        {updateActivity: ActivityResponse},
        {input: ActivityUpdateModelInput}
    >(activityMutations.UPDATE_ACTIVITY);

    return {
        updateActivity,
        updateActivityResponse: data?.updateActivity,
        updateActivityLoading: loading,
    };
};

export const useRemoveActivitiesByIds = () => {
    const [removeActivitiesByIds, {data, loading}] = useMutation<
        {removeActivitiesByIds: ResponseViewModel<string>},
        {ids: string[]}
    >(activityMutations.REMOVE_ACTIVTIES_BY_IDS);

    return {
        removeActivitiesByIds,
        removeActivitiesByIdsResponse: data?.removeActivitiesByIds,
        removeActivitiesByIdsLoading: loading,
    };
};
